import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Alert, Container, Box } from '@mui/material';

const ProtectedAdminRoute = ({ children, allowGarageManager = false }) => {
  const user = useSelector(state => state.auth.user);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  const allowedRoles = ['admin', 'org_admin'];
  if (allowGarageManager) allowedRoles.push('garage_manager');

  if (!allowedRoles.includes(user?.role) && !user?.is_superuser) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box>
          <Alert severity="error">
            Access Denied: Insufficient privileges to access this page.
          </Alert>
        </Box>
      </Container>
    );
  }

  return children;
};

export default ProtectedAdminRoute;
